import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="py-12 md:py-20 bg-white" data-id="element-153">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-154">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-slate-50 border border-slate-200 rounded-3xl p-8 md:p-12 text-center relative overflow-hidden" data-id="element-155">
          <div className="absolute top-0 left-0 w-full h-2 bg-brand-accent" data-id="element-156"></div>

          <div className="mx-auto bg-white w-20 h-20 rounded-full flex items-center justify-center shadow-md mb-6 border border-slate-100" data-id="element-157">
            <ShieldCheckIcon className="w-10 h-10 text-brand-accent" data-id="element-158" />
          </div>

          <h2 className="text-3xl font-bold text-slate-900 mb-6" data-id="element-159">
            Garantía total de 30 días
          </h2>

          <div className="space-y-4 text-slate-700 text-lg max-w-2xl mx-auto" data-id="element-160">
            <p className="font-medium text-slate-900" data-id="element-161">
              Si en 30 días sentís que estas planillas no te ahorran tiempo ni
              mejoran la organización de tu consultorio, te devolvemos el 100%
              de tu dinero.
            </p>
            <p data-id="element-162">
              Así funciona: nos escribís por email, te devolvemos el pago. Sin
              formularios, sin justificaciones, sin demoras.
            </p>
            <p className="text-sm bg-white p-4 rounded-lg border border-slate-100 mt-6 italic" data-id="element-163">
              Menos del 2% de quienes compran piden devolución. Eso no lo
              decimos para presumir, lo decimos para que entiendas que el
              producto funciona.
            </p>
            <p className="font-bold text-brand-dark mt-6" data-id="element-164">
              El único riesgo real es seguir perdiendo horas en tareas
              administrativas.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}